<template>
  <router-link to="/contact-us" class="button">
    <span>Talk to us</span>
  </router-link>
</template>

<script>
export default {
  name: 'talk-to-us-button'
}
</script>

<style lang="scss">
.button {
 @include button;
}
</style>
